import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './http'
import VueAxios from 'vue-axios'
const VueLayers = require('vuelayers')
import 'vuelayers/lib/style.css' // needs css-loader
const HeatmapLayer = require( '@/Emgyne/HeatmapLayer.js' );
import { authUser } from '@/auth/User';
const infiniteScroll = require( 'vue-infinite-scroll' );
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
 
Vue.use(VueSweetalert2);

Vue.use( VueAxios, axios );
Vue.use(VueLayers, {
  dataProjection: 'EPSG:4326',
})


// Vue.use(HeatmapLayer, {
//     dataProjection: 'EPSG:4326',
// })

Vue.use(infiniteScroll)


axios.interceptors.request.use( ( config ) =>
{
    if( authUser.isAuthenticated() )
        config.headers['Authorization'] = 'Bearer ' + authUser.access_token;
    
    const system: string = /emgyne/.test( config.url || '' ) ? 'emgyne' : 'emma';
    let city = null;
    if (system == 'emma' ) 
    {
        if ('admin' in authUser.roles || 'coc' in authUser.roles) city = authUser.emmaCity;
    }
    else if( system == 'emgyne' ) 
    {
        if( 'admin' in authUser.roles || 'engineer' in authUser.roles ) city = authUser.emgyneCity
    }
    if( city )
    {
        if( config.method == 'post' || config.method == 'put' )
        {
            config.data = config.data || new FormData();
            if( config.data instanceof FormData )
            config.data.append( 'city', city );
        }
        else
        {
            config.params = config.params || {};
            config.params['city'] = city;
        }
    }
    return config;
});

axios.interceptors.response.use(
    ( response ) =>
    {
        return response;
    },
    ( error ) =>
    {
        if( error )
        {
            if( error.response && error.response.status === 401 )
            {
                if (error.config && !error.config.url.endsWith('auth/refresh')) {
                    return authUser.refresh().then( () => {
                        error.config.headers['Authorization'] = 'Bearer ' + authUser.access_token;
                        return Promise.resolve( axios.request( error.config ) );
                    }).catch(() => {
                        let url: string = error.config.url.replace( /(emgyne|emma).*$/, '$1' )
                        if (url.startsWith( process.env.VUE_APP_API_URL ) )
                            url = url.replace( process.env.VUE_APP_API_URL, '/' );
                        router.replace(
                            { path: '/auth/login', query: { 'return_url': url } }
                        )
                    })
                }
                else if( error.response && error.response.status === 403)
                    router.replace( '/Unauthorized' );
                else {
                    let url = error.config.url.replace(/(emgyne|emma).*$/, '$1')
                    if (url.startsWith(process.env.VUE_APP_API_URL))
                        url = url.replace(process.env.VUE_APP_API_URL, '/');
                    router.replace({
                        path: "/auth/login",
                        query: {
                            return_url: url
                        }
                    });
                }
            }
            else
                return Promise.reject( error );
        }
        else
            return Promise.resolve();
    }
);


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
